import {
  Button,
  CircularProgress,
  Drawer,
  Menu,
  MenuItem,
  Radio,
  Select,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  DashboardCustomize,
  ErrorOutline,
  KeyboardArrowDown,
  SettingsInputComponent,
  KeyboardArrowRight,
  Logout,
  Support,
  SupportAgent,
} from "@mui/icons-material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const Sidebar = ({ open, setOpen, orgs }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));

  const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const changeOrganization = async (org_id) => {
    try {
      let org = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "get-organization",
        { orgId: org_id }
      );
      localStorage.setItem(
        "organization",
        JSON.stringify(org.data.organization)
      );

      window.location.reload()
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  console.log();

   const [anchorEl, setAnchorEl] = useState(null);
    const open_ = Boolean(anchorEl);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  return (
    <Drawer open={open} onClose={() => setOpen(false)}>
      <div className="text-[16px] space-y-3 bg-white   flex-1 w-[200px]">
        {location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/call-details') ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard");
            }}
            className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
            {" "}
            <img src="/icons/dash-active.png" className="w-[20px] mr-2" />{" "}
            Dashboard{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
            onClick={() => {
              setOpen(false);
              navigate("/dashboard");
            }}
          >
            {" "}
            <img
              src="/icons/dash-inactive.png"
              className="w-[20px] mr-2"
            />{" "}
            Dashboard{" "}
          </div>
        )}

        {location.pathname.startsWith('/dashboard/call-routings') || location.pathname.startsWith('/dashboard/call-route')
          || location.pathname.startsWith('/dashboard/create-route')
          ? (
            <div
              onClick={() => {
                setOpen(false);
                navigate("/dashboard/call-routings");
              }}
              className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
              {" "}
              <img src="/icons/call-active.png" className="w-[20px] mr-2" /> Call
              Routing{" "}
            </div>
          ) : (
            <div
              className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
              onClick={() => {
                setOpen(false);
                navigate("/dashboard/call-routings");
              }}
            >
              {" "}
              <img
                src="/icons/call-inactive.png"
                className="w-[20px] mr-2"
              />{" "}
              Call Routing{" "}
            </div>
          )}

        {location.pathname.startsWith('/dashboard/dialer') ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/dialer");
            }}
            className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
            {" "}
            <img
              src="/icons/dailer-active.png"
              className="w-[20px] mr-2"
            />{" "}
            Dialer{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/dialer");
            }}
          >
            {" "}
            <img
              src="/icons/dailer-inactive.png"
              className="w-[20px] mr-2"
            />{" "}
            Dialer{" "}
          </div>
        )}

        {location.pathname.startsWith('/dashboard/channels') ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/channels");
            }}
            className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
            {" "}
            <img
              src="/icons/notification-active.png"
              className="w-[20px] mr-2"
            />{" "}
            Channels{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/channels");
            }}
          >
            {" "}
            <img
              src="/icons/notification-inactive.png"
              className="w-[20px] mr-2"
            />{" "}
            Channels{" "}
          </div>
        )}

        {location.pathname.startsWith('/dashboard/recordings') ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/recordings");
            }}
            className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
            {" "}
            <img
              src="/icons/microphone-active.png"
              className="w-[20px] mr-2"
            />{" "}
            Recordings{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/recordings");
            }}
          >
            {" "}
            <img
              src="/icons/microphone-inactive.png"
              className="w-[20px] mr-2"
            />{" "}
            Recordings{" "}
          </div>
        )}

        {location.pathname.startsWith('/dashboard/settings') ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/settings");
            }}
            className="cursor-pointer flex items-center text-[#605CFF] bg-gradient-to-r from-[#EBEBFC] to-[#fff] py-2 px-3">
            {" "}
            <img
              src="/icons/settings-active.png"
              className="w-[20px] mr-2"
            />{" "}
            Settings{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3 text-[#7f7f92]"
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/settings");
            }}
          >
            {" "}
            <img
              src="/icons/settings-inactive.png"
              className="w-[20px] mr-2"
            />{" "}
            Settings{" "}
          </div>
        )}
      </div>

      {err_msg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
          <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
        </div>
      )}



      {/* <div className=" flex justify-center  items-center py-2 px-3 font-semibold ">
        {" "}
        <div className="space-y-2">
          <div className="text-left w-[130px]">
            {" "}
            {
              JSON.parse(localStorage.getItem("organization"))?.organization_name
                .S
            }{" "}
          </div>

          <div className="w-[180px] mx-auto ">
            {loader ? (
              <CircularProgress size={"1.3rem"} sx={{ color: "blue" }} />
            ) : (
              <Select
                IconComponent={KeyboardArrowDown}
                fullWidth
                value={
                  user?.relatedOrgs.L.filter(
                    (e) =>
                      e?.M.org_id.S ===
                      JSON.parse(localStorage.getItem("organization")).orgId.S
                  )[0]?.M.org_id.S
                }
                onChange={(f) => {
                  changeOrganization(f.target.value);
                }}
                className="mb-2 bg-[#F7F7F8]"
                sx={{
                  fontSize: "13px",
                  padding: "2px 8px", // Adjust padding here
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "& .MuiSelect-select": {
                    padding: "2px 8px", // Adjust padding for the text inside Select
                  },
                }}
              >
                {user?.relatedOrgs.L.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item?.M.org_id.S}>{orgs?.find((e) => e.orgId.S === item?.M.org_id.S)?.organization_name.S}</MenuItem>
                  );
                })}
              </Select>
            )}
          </div>
          <div className="flex justify-center">
            <Button
              sx={{
                textTransform: "none",
                bgcolor: "#E6E6E6",
                color: "#244F62",
                py: "10px",
                px: "9px",
                borderRadius: "6px",
                fontSize: { lg: "14px", xs: "14px" },
                width: "40vw",
              }}
            >
              Support
            </Button>
          </div>

          <div className="flex justify-center">
            <Button
              sx={{
                textTransform: "none",
                bgcolor: "#605BFF",
                color: "white",
                py: "10px",
                px: "9px",
                borderRadius: "6px",
                fontSize: { lg: "14px", xs: "14px" },
                width: "40vw",
              }}
              onClick={() => {
                localStorage.clear("user");
                localStorage.clear("organization");
                navigate("/login");
              }}
            >
              Log Out
            </Button>
          </div>
        </div>
      </div> */}

      <div className="px-3  left-[10%]   absolute w-[80%] bottom-4 mt-auto bg-[#F7F7F8] py-1 rounded-lg">
                        <div className=" text-[14px]  font-semibold">
                        {
                        JSON.parse(localStorage.getItem("organization"))?.organization_name
                        .S.length > 17 ?
                      JSON.parse(localStorage.getItem("organization"))?.organization_name
                        .S.slice(0,17)+"..." : 
                        JSON.parse(localStorage.getItem("organization"))?.organization_name
                        .S
                    }{" "}
                          {/* <img src="/icons/Logout.png" className="w-[20px] ml-2 cursor-pointer" 
                  onClick={()=> {
                    localStorage.clear('user')
                    localStorage.clear('organization')
                    navigate('/login')
                  }}
                  />{" "} */}
                        </div>
      
                        <div className='text-[13px] text-black flex items-center justify-between'>
                          <div>
                         
                            {JSON.parse(localStorage.getItem("user"))?.email
                              .S}
                          </div>
      
                          <KeyboardArrowRight
                          id="menu-button"
                          aria-controls={open ? "menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={handleClick}
                          sx={{ fontSize: "20px", cursor:'pointer' }} />
      
      <Menu
              id="menu"
              anchorEl={anchorEl}
              open={open_}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "menu-button",
              }}
            >
               {user?.relatedOrgs.L.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item?.M.org_id.S}
                                onClick={()=> {
                                  changeOrganization(item?.M.org_id.S)
                                }}
                                sx={{
                                  "& .MuiPaper-root": {
                                    padding: 0, // Remove padding around the menu
                                    margin: 0, // Ensure no margin
                                  },
                                  "& .MuiMenu-list": {
                                    padding: 0, // Remove padding inside the menu list
                                    margin:0
                                  },
                                }}
                                >
                                  <div className='text-[14px]  '>
                                   <Radio
                                   
                                   checked={
                                        item.M.org_id.S ===
                                        JSON.parse(localStorage.getItem("organization")).orgId.S
                                     ? true : false 
                                   }
                                   sx={{
                                    "& .MuiSvgIcon-root": {
                                      fontSize: 16, // Size of the radio icon
                                      color: "#605BFF", // Default color for unchecked radio
                                    },
                                    "&.Mui-checked .MuiSvgIcon-root": {
                                      color: "#605BFF", // Color when radio is checked
                                    },
                                  }}
                                      />
                                  {orgs?.find((e) => e.orgId.S === item?.M.org_id.S)?.organization_name.S}
                                  </div>
                                </MenuItem>
                              );
                            })}

<MenuItem onClick={
                ()=>{
                 handleClose()
                }
              } sx={{ bgcolor:'white', color:'black', fontWeight:'500'}} >
              <a href='mailto:hello@twilanswer.com' className="text-[14px] flex justify-center w-full" >  Contact Support</a>
              </MenuItem>



              <MenuItem onClick={
                ()=>{
                  navigate('/login')
                  localStorage.clear()
                }
              } sx={{ bgcolor:'white', color:'red', fontWeight:'500'}} >
              <div className="text-[14px] flex justify-center w-full" > <Logout sx={{ fontSize:'18px'}} /> Log out</div>
              </MenuItem>
            </Menu>
                        </div>
                      </div>
    </Drawer>
  );
};

export default Sidebar;
